import React from 'react';
import buildUrl from './buildUrl';
import {List} from 'immutable';
import AuthStore from 'stores/AuthStore';
import {BullseyeIcon} from '@components/icon/BullseyeIcon';
import DashboardSidebar from 'components/pure/admin/DashboardSidebar';
import {PhoneIcon} from '@components/icon/PhoneIcon';
import {OverlappingCommentsIcon} from '@components/icon/OverlappingCommentsIcon';
import {ScorecardIcon} from '@components/icon/ScorecardIcon';
import {ChartLineUpIcon} from '@components/icon/ChartLineUpIcon';
import {MemoIcon} from '@components/icon/MemoIcon';

const sidebarMenu = props => {
  const path = buildUrl(props);
  const coach = props.coach;
  const sessionUser = AuthStore.getState().user;
  const forCoachString =
    coach && sessionUser.id !== coach.id ? `For ${coach.firstName} ` : 'For You';

  const coachingChildren = List([
    {
      name: 'Coaching Plans',
      url: `${path}/coaching-plans`,
    },
    {
      name: 'Coaching Effectiveness',
      url: `${path}/coaching-effectiveness`,
    },
    {
      name: `Coaching Plans ${forCoachString}`,
      url: `${path}/coaching-plans-for-you`,
    },
  ]);

  const reviewActivitiesChildren = List([
    {
      name: 'Self Review',
      url: `${path}/self-review`,
    },
    {
      name: 'Other Review',
      url: `${path}/other-review`,
    },
  ]);

  const coachingReceivedChildren = List([
    {
      name: 'From manager',
      url: `${path}/coaching-from-manager`,
    },
    {
      name: 'From others',
      url: `${path}/coaching-from-others`,
    },
  ]);

  return List([
    {
      name: 'Summary',
      icon: MemoIcon,
      url: `${path}/summary`,
    },
    {
      name: 'Coaching',
      icon: ChartLineUpIcon,
      children: coachingChildren,
    },
    {
      name: 'Call Activity',
      icon: PhoneIcon,
      url: `${path}/call-activity`,
    },
    {
      name: 'Review Activities',
      icon: ScorecardIcon,
      children: reviewActivitiesChildren,
    },
    {
      name: 'Coaching Received',
      icon: OverlappingCommentsIcon,
      children: coachingReceivedChildren,
    },
    {
      name: 'Calls',
      icon: PhoneIcon,
      url: `${path}/calls`,
    },
    props.showKpiTab && {
      name: 'KPIs',
      icon: BullseyeIcon,
      url: `${buildUrl(props)}/kpi`,
    },
  ]).filter(x => x);
};

export default class CoachDashboardSidebar extends React.Component {
  render() {
    return (
      <DashboardSidebar
        sidebarMenu={sidebarMenu(this.props)}
        sidebarOpen={this.props.sidebarOpen}
        className="dashv2-coach"
      />
    );
  }
}
